<template>
	<div class="tab-body">
		<div class="search">
			<el-form ref="form" :model="searchParams" label-width="89px">
				<el-row>
					<el-col :span="6">
						<el-form-item label="代金券">
							<el-input v-model="searchParams.skname"></el-input>
						</el-form-item>
					</el-col>

					<el-collapse-transition>
						<div v-if="isShowMoreSearch">
							<!--隐藏区域-->
						</div>
					</el-collapse-transition>
					<div class="search-btn">
						<el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
						<el-button @click="clearSearchVal">清空</el-button>
						<el-button type="text" v-if="!isShowMoreSearch" @click="isShowMoreSearch = !isShowMoreSearch">
							更多
							<i class="el-icon-arrow-down"></i>
						</el-button>
						<el-button type="text" v-else @click="isShowMoreSearch = !isShowMoreSearch">
							收起
							<i class="el-icon-arrow-up"></i>
						</el-button>
					</div>
				</el-row>
			</el-form>
		</div>
		<div class="operator">
			<el-button type="primary" icon="el-icon-plus" @click="toSave()">添加</el-button>
			<el-button type="danger" icon="el-icon-delete" @click="batchRemove()">批量删除</el-button>
		</div>
		<div class="dataTable autoFlex" v-if="listData">
			<el-table class="table" :data="listData.records" stripe border height="auto"
				@selection-change="selectionChange" v-loading="listLoading">
				<el-table-column type="selection" width="55" fixed="left"></el-table-column>
				<el-table-column prop="dname" width="130" label="代金券名字"></el-table-column>
				<el-table-column prop="image" width="100" label="图片">
					<template slot-scope="scope">
						<el-image :src="BaseUrl + scope.row.image" v-if="scope.row.image"></el-image>
					</template>
				</el-table-column>
				<el-table-column prop="cost" width="90" label="减免金额">
					<template slot-scope="props">
						{{ props.row.cost }}元
					</template>
				</el-table-column>
				<el-table-column prop="status" width="90" label="状态">
					<template slot-scope="props">
						<el-tag size="mini" type="warning"
							v-if=" props.row.status === 0 ">已过期</el-tag>
						<el-tag size="mini" v-else-if="props.row.status === 1" type="success">进行中</el-tag>
						
					</template>
				</el-table-column>
				<el-table-column prop="starttime" width="200" label="周期">
					<template slot-scope="props">
						<el-tag size="mini" type="success"> {{ props.row.starttime }} </el-tag>
						~ <el-tag size="mini" type="danger"> {{ props.row.endtime }} </el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="maximum"    label="内容">
					<template slot-scope="props">
						满{{ props.row.maximum }}元减{{ props.row.cost }}元
					</template>
				</el-table-column>
				<!-- <el-table-column prop="crer" label="创建人"></el-table-column>
						<el-table-column prop="mder" label="修改人"></el-table-column>
						<el-table-column prop="mdtm" label="修改时间"></el-table-column>
						<el-table-column prop="crtm" label="创建时间"></el-table-column> -->
				<el-table-column label="操作" fixed="right" width="310px">

					<template slot-scope="scope">
						<div class="dataTable-operator">
							<el-button size="mini" icon="el-icon-search"
								@click="toDetail(scope.$index, scope.row)">详情</el-button>
							<el-button size="mini" icon="el-icon-edit"
								@click="toUpdate(scope.$index, scope.row)">编辑</el-button>
							<el-button size="mini" icon="el-icon-delete" type="danger"
								@click="remove(scope.$index, scope.row)">删除</el-button>
							<el-button size="mini" type="success" v-if="!scope.row.image"
								@click="ToUpload(scope.$index, scope.row)">上传</el-button>
							<el-button size="mini" type="success" v-if="scope.row.image"
								@click="ToUpload(scope.$index, scope.row)">更新</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>


			<!-- 上传收据消息 -->
			<el-dialog title="上传轮播图" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
				<el-form class="dataForm" ref="form" :model="uploadParameter" :inline="true" label-width="80px">
					<el-row>
						<el-col :span="12" class="userHead" style="margin-left: 30px;">
							<drag-file-upload  @change="change" v-model="uploadParameter.image" drag
								uri="/statics/voucher" model="fileSystem" :size="20480"></drag-file-upload>
							<div style=" font-weight: bold;">
							</div>
						</el-col>

					</el-row>
				</el-form>

				<span slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible = false">关 闭</el-button>
				</span>

			</el-dialog>

			<div class="pageBar">
				<el-pagination @size-change="sizeChange" @current-change="currentChange" :total="listData.total"
					:page-size="page.size" :current-page="page.current" :layout="this.$constant.page.layout"
					:page-sizes="this.$constant.page.pageSizes"></el-pagination>
			</div>
		</div>
		<edit ref="edit"></edit>
	</div>
</template>

<script>
import edit from './edit.vue';
import api from '@/api/xueli/voucher.js';
import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";
import imageUpload from '@/components/biz/imageUpload/imageUpload.vue';
import dragFileUpload from '@/components/biz/fileUpload/dragFileUpload.vue';
import constant from '@/util/constant.js';
import { status } from 'nprogress';
export default {
	name: 'voucher',
	components: {
		edit,
		selectOptionDictionary,
		imageUpload,
		dragFileUpload,
	},
	data() {
		return {
			searchParams: {},
			isShowMoreSearch: false,
			listLoading: false,
			listData: [],
			selected: [],

			uploadIdx:0,
			uploadParameter: {},

			dialogVisible: false,
			BaseUrl:'',
			page: new this.$constant.pageObj(),
		};
	},
	methods: {
		handleClose() {
			this.uploadParameter = {};
			this.dialogVisible = false
		},
		change(val) { 
			//console.log(  "上传后", val ,  this.formParameter.image)

			      //保存相对地址
				if( val && val.indexOf("statics")>0){
					this.uploadParameter.image = val.substring(val.indexOf("statics")-1    )
				}
 
				api.update( this.uploadParameter,
					response => {
						this.$utils.msg.success(response.msg);
						this.dialogVisible = false;
						 //this.$set(this.listData.records.uploadIdx,this.uploadIdx,this.uploadParameter.image)
                                     //强制显示刷新
						 this.listData.records[this.uploadIdx].image = this.uploadParameter.image
						 this.$forceUpdate()
					},
					response => {
						this.$utils.msg.warning(response.msg);

					}
				);
		},
		//获取数据
		list() {
			this.listLoading = true;
			this.BaseUrl = constant.serverUrl
			let params = this.$utils.merger(this.searchParams, this.page);
			api.list(params, response => {
				this.listData = response.data;
				this.listLoading = false;
			})
		},
		//去添加
		toSave() {
			this.$refs.edit.open({}, '添加');
		},
		//去编辑
		toUpdate(index, row) {
			let editParameter = {
				id: row.id
			};
			this.$refs.edit.open(editParameter, '编辑');
		},
		//去详情
		toDetail(index, row) {
			let detailParameter = {
				id: row.id
			};
			this.$refs.edit.open(detailParameter, '详情', true);
		},
		//删除
		remove(index, row) {
			let parameter = {
				ids: row.id
			}
			this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				api.remove(
					parameter,
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
		//批量删除
		batchRemove() {
			if (!this.selected || this.selected.length == 0) {
				this.$utils.msg.info('请选择至少一行');
				return;
			}
			let parameter = {
				ids: this.selected
			};
			this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				api.remove({
					ids: this.selected
				},
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
		//改变选择项
		selectionChange(val) {
			//清空
			this.selected = [];
			for (let item of val) {
				this.selected.push(item.id);
			}
		},
		//改变每页显示数量
		sizeChange(val) {
			this.page.size = val;
			this.list();
		},
		//改变现在的页码
		currentChange(val) {
			this.page.current = val;
			this.list();
		},

		//搜索
		search() {
			this.list();
		},
		//清空搜索框
		clearSearchVal() {
			this.searchParams = {};
		},
		ToUpload(index, row) {

			this.uploadIdx = index

			this.uploadParameter = {
				id: row.id,
				itemId: row.itemId,
				isShow: row.isShow,
			};

			this.dialogVisible = true;
			// this.$refs.edit2.open(uploadParameter, '上传');
		},
		confirm() {

			// this.$utils.checkForm(this.$refs.form, () => {
			// 	//添加
			// 	let parameter = this.$utils.merger(this.formParameter, this.uploadParameter);
			// 	api.upload(parameter,
			// 		response => {
			// 			this.$utils.msg.success(response.msg);
			// 			this.dialogVisible = false;
			// 			this.close();
			// 			this.$parent.list();
			// 		},
			// 		response => {
			// 			this.$utils.msg.warning(response.msg);

			// 		}
			// 	);
			// 	this.list();
			// });

		},
	},
	mounted() {
		this.list();
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
</style>
